import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { content, getLangFromPath } from '../i18n';

function CookieBanner() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const t = content[lang];

  useEffect(() => {
    CookieConsent.run({
      revision: 1,
      autoShow: true,
      disablePageInteraction: false,
      guiOptions: {
        consentModal: {
          layout: 'box',
          position: 'bottom right',
          equalWeightButtons: true,
          flipButtons: false
        },
        preferencesModal: {
          layout: 'box',
          position: 'right',
          equalWeightButtons: true,
          flipButtons: false
        }
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true
        },
        analytics: {
          enabled: false,
          readOnly: false
        }
      },
      language: {
        default: 'en',
        translations: {
          en: {
            consentModal: content.en.cookies.consentModal,
            preferencesModal: content.en.cookies.preferencesModal
          },
          gr: {
            consentModal: content.gr.cookies.consentModal,
            preferencesModal: content.gr.cookies.preferencesModal
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    CookieConsent.setLanguage(lang, true);
  }, [lang]);

  const openCookieBanner = () => {
    CookieConsent.show(true);
  };

  return (
    <button
      type="button"
      className="cookie-settings-trigger"
      onClick={openCookieBanner}
      aria-label={t.cookies.settingsButton}
    >
      {t.cookies.settingsButton}
    </button>
  );
}

export default CookieBanner;